/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useContext } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getCompanyInfo,
  postCompanyInfo,
  deleteCompanyInfo,
  getCompanyType,
} from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { Select, Input, Button } from 'antd'
import R from 'ramda'
import styled from 'styled-components'
import { STORE_COMPANY_NAME_MAP } from 'core/action-names'
import { ErrorContext } from 'context'
const TableTD = styled.td`
  text-align: end;
`

// const companyTypes = {
//   UTILITY: 'UTILITY',
//   MERCHANT: 'MERCHANT',
//   MAIN: 'MAIN',
// }

const headers = companyTypes => [
  strCol({
    ident: 'companyId',
    display: 'Company Id',
    isKey: true,
    width: 150,
  }),
  strCol({
    ident: 'companyName',
    display: 'Company Name',
    width: 320,
    isFiltered: true,
    isRequired: true,
    sortIndexGetter: ({ rowData }) => rowData.companyName,
  }),
  strCol({
    ident: 'companyType',
    display: 'Company Type',
    ...toSelectionColProps(companyTypes),
    isFiltered: true,
    width: 150,
    isRequired: true,
  }),
  strCol({
    ident: 'contactFirstName',
    display: 'First Name',
    isFiltered: true,
    isRequired: false,
    width: 200,
  }),
  strCol({
    ident: 'contactLastName',
    display: 'Last Name',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'contactTitle',
    display: 'Title',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'contactPhone',
    display: 'Phone',
    width: 150,
  }),
  strCol({
    ident: 'contactFax',
    display: 'Fax',
    width: 150,
  }),
  // strCol({
  //   ident: 'contactPager',
  //   display: 'Pager',
  // }),
  strCol({
    ident: 'contactEmail',
    display: 'Email',
    width: 220,
  }),
  modifierCol,
  modifiedDateCol,
]

const requiredField = () => <span style={{ color: 'red' }}>*</span>

const retrieveTask = apiTargetInfo => getCompanyInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data => postCompanyInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteCompanyInfo(apiTargetInfo)(data)

const title = 'Company'

const Company = props => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [companyType, setCompanyType] = useState([])
  const { setError } = useContext(ErrorContext)

  useEffect(
    _ => {
      getCompanyType(props.apiTargetInfo).fork(setError, data => {
        //  setCompanyType(data.map(a => ({ [a]: a })).reduce((a, b) => ({ ...a, ...b }), {}))
        setCompanyType(data)
      })
    },
    [props.apiTargetInfo, setError]
  )

  const reloadCompany = data => {
    // retrieveTask(props.apiTargetInfo).fork(setErr, data => {
    //   props.saveCompanyNameMap(data))
    const d = R.compose(
      R.reduce((a, b) => ({ ...a, ...b }), {}),
      R.map(([k, v]) => ({ [k]: v })),
      R.map(r => [r.companyId, r.companyName])
    )(data)
    props.saveCompanyNameMap(d)
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <table
      style={{ width: '100%', borderSpacing: '5px', borderCollapse: 'inherit' }}
    >
      <tbody>
        <tr>
          <TableTD>Company Id {requiredField()}:</TableTD>
          <td style={{ minWidth: '150px' }}>
            <Input
              key="companyId"
              value={insertData.companyId}
              placeholder="Company Id"
              name="companyId"
              onChange={e =>
                setInsertData({ ...insertData, companyId: e.target.value })
              }
              maxLength={12}
            />
          </td>
          <TableTD>Company Name {requiredField()}:</TableTD>
          <td style={{ minWidth: '150px' }}>
            <Input
              key="companyName"
              value={insertData.companyName}
              placeholder="Company Name"
              name="companyName"
              onChange={e =>
                setInsertData({ ...insertData, companyName: e.target.value })
              }
            />
          </td>
          <TableTD>Company Type {requiredField()}:</TableTD>
          <td>
            <Select
              style={{ minWidth: '100%' }}
              className="companyType"
              placeholder="Company Type"
              onChange={value =>
                setInsertData({ ...insertData, companyType: value })
              }
            >
              {companyType.map(m => (
                <Select.Option value={m.companyType}>
                  {m.companyType}-{m.description}
                </Select.Option>
              ))}
            </Select>
          </td>
        </tr>
        <tr>
          <TableTD>First Name :</TableTD>
          <td>
            <Input
              key="contactFirstName"
              value={insertData.contactFirstName}
              placeholder="First Name"
              name="contactFirstName"
              onChange={e =>
                setInsertData({
                  ...insertData,
                  contactFirstName: e.target.value,
                })
              }
            />
          </td>
          <TableTD>Last Name :</TableTD>
          <td>
            <Input
              key="contactLastName"
              value={insertData.contactLastName}
              placeholder="Last Name"
              name="contactLastName"
              onChange={e =>
                setInsertData({
                  ...insertData,
                  contactLastName: e.target.value,
                })
              }
            />
          </td>
          <TableTD>Title :</TableTD>
          <td style={{ minWidth: '150px' }}>
            <Input
              key="contactTitle"
              value={insertData.contactTitle}
              placeholder="Title"
              name="contactTitle"
              onChange={e =>
                setInsertData({ ...insertData, contactTitle: e.target.value })
              }
            />
          </td>
        </tr>
        <tr>
          <TableTD>Phone :</TableTD>
          <td style={{ minWidth: '150px' }}>
            <Input
              key="contactPhone"
              value={insertData.contactPhone}
              placeholder="Phone"
              name="contactPhone"
              onChange={e =>
                setInsertData({ ...insertData, contactPhone: e.target.value })
              }
            />
          </td>
          <TableTD>Email :</TableTD>
          <td colSpan={3} style={{ minWidth: '150px' }}>
            <Input
              key="contactEmail"
              value={insertData.contactEmail}
              placeholder="Email"
              name="contactEmail"
              onChange={e =>
                setInsertData({ ...insertData, contactEmail: e.target.value })
              }
            />
          </td>

          {/* <TableTD>Pager :</TableTD> */}
          <td style={{ minWidth: '150px' }}>
            {/* <Input
                key="contactPager"
                value={insertData.contactPager}
                placeholder="Pager"
                name="contactPager"
                onChange={e =>
                  setData({ contactPager: e.target.value })
                }
              /> */}
          </td>
          <td />
          <td />
        </tr>
        <tr>
          <TableTD>Fax :</TableTD>
          <td style={{ minWidth: '150px' }}>
            <Input
              key="contactFax"
              value={insertData.contactFax}
              placeholder="Fax"
              name="contactFax"
              onChange={e =>
                setInsertData({ ...insertData, contactFax: e.target.value })
              }
            />
          </td>
          <td />
          <td>
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
            <Button
              style={{ marginLeft: '20px' }}
              type="primary"
              onClick={() => onAdd(false)}
            >
              Add & Hide
            </Button>
            <Button
              style={{ marginLeft: '20px' }}
              type="danger"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  )

  const HeaderType = R.compose(
    R.reduce((a, b) => ({ ...a, ...b }), {}),
    R.map(a => ({ [a.companyType]: a.companyType }))
  )(companyType || [])

  return [
    <CommonScreen
      title={title}
      header={headers(HeaderType)}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.companyName}
      autoRetrieve
      // sortOptions={[{ ident: 'companyName', display: 'Company Name', sortOrder: 'asc' }]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={200}
      onInsertEvent={b => setInsertEvent(b)}
      onRetrieveData={reloadCompany}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

const mapDispathcToProps = dispatch => ({
  saveCompanyNameMap: company =>
    dispatch({ type: STORE_COMPANY_NAME_MAP, payload: company }),
})

export default connect(mapStateToProps, mapDispathcToProps)(Company)
